import { useTranslation } from "react-i18next";

import FormControlLabel from "@mui/material/FormControlLabel";

import { Checkbox } from "../../../../../../../components";

const GoogleCheckbox = ({ selectedValue, onChange, label }) => {
  const { t } = useTranslation();

  const isChecked =
    (label === t("global.yes") && selectedValue === "true") ||
    (label === t("global.no") && selectedValue === "false");

  const handleChange = () => {
    if (label === t("global.yes")) {
      onChange(selectedValue === "true" ? "" : "true");
    } else if (label === t("global.no")) {
      onChange(selectedValue === "false" ? "" : "false");
    }
  };

  return (
    <FormControlLabel
      control={
        <Checkbox
          variant="gray"
          color="primary"
          checked={isChecked}
          onChange={handleChange}
        />
      }
      label={label}
    />
  );
};

export default GoogleCheckbox;
